module.exports = __webpack_public_path__ + "static/media/14@2x.bbe7ec3b.png";